import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import orthotic from "../../assets/img/orthotic.jpg";

/**
 * Orthotics detail page component
 */
const OrthoticsDetail = () => {
  return (
    <ServiceDetailLayout
      title="Orthotics"
      description="Custom orthotics and insoles manufactured to reduce pressure, adjust gait, and provide cushioning. Individually prescribed for your specific needs."
      image={orthotic}
      imageAlt="Custom Orthotics"
    >
      <h1 className="gs-u-mb+">Orthotic Therapy</h1>

      <h2 className="gs-u-mb+">What are orthotics?</h2>
      <p className="text--large gs-u-mb++">
        Orthotics, also referred to as orthoses, are inserts for shoes that
        change the angle of your feet, aligning them with your ankles and legs.
      </p>

      <h2 className="gs-u-mb+">What are orthotics used for?</h2>
      <p className="gs-u-mb+">
        At The Moffat Foot Clinic, we recommend and prescribe orthotics for many
        uses, including:
      </p>
      <ul className="gs-u-mb++ benefits-list">
        <li>
          reducing the long-term effects of trauma injuries such as sprains and
          fractures;
        </li>
        <li>
          relieving pain caused by overuse injuries such as
          <ul className="benefits-list">
            <li>plantar fasciitis</li>
            <li>Achilles tendinopathy</li>
            <li>peroneal tendinitis</li>
            <li>shin splints</li>
            <li>patellofemoral syndrome</li>
            <li>posterior tibial tendon dysfunction</li>
          </ul>
        </li>
        <li>preventing or managing foot ulcers in people with diabetes</li>
        <li>relieving foot fatigue in people with arthritis</li>
        <li>
          preventing or halting the development of foot deformities such as
          bunions and hammertoes
        </li>
        <li>
          preventing or treating problems in children such as flat feet, intoed
          gait, growth plate inflammation, Sever's disease and Osgood-Schlatter
          disease
        </li>
        <li>
          reducing injury occurrence and increasing performance in people active
          in sports.
        </li>
      </ul>

      <p className="gs-u-mb++">
        When fitted properly, orthotics can help not just your feet, but also
        your ankles, lower legs, knees, hips, and lower back.
      </p>

      <h2 className="gs-u-mb+">What should I do if I need orthotics?</h2>
      <p className="gs-u-mb+">
        Our podiatrists at The Moffat Foot Clinic boast more than 30 years of
        expertise in orthotic therapy.
      </p>

      <p className="gs-u-mb++">
        Should you or your child think orthotics might help, reach out to us.
      </p>
    </ServiceDetailLayout>
  );
};

export default OrthoticsDetail;
